import { BaseListViewStore, OrderLinesHyperlinkCellData, MultipleCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { OrderLineStore } from 'modules/order-line/stores';
import { ModalParams, ConfirmModalParams } from 'core/models';
import { notificationError } from 'core/utils';
import { channelType, sourceOfChange } from 'common/constants';
import _ from 'lodash';
import { LinkOrderLine } from '../pages';

class OrderLinesListViewStore extends BaseListViewStore {
	@observable change = false;
	noDataItem = true;
	hasPiiAccess = false;

	constructor(rootStore, componentProps) {
		super(rootStore, {
			listStore: new FulfillmentOrderStore(rootStore),
			queryParams: {
				embed: [],
				filter: null,
				ignore: true,
			},

			tableData: {
				columns: [
					{
						key: 'sku',
						title: 'ORDERLINEVIEW.SKU',
						selected: true,
						width: 200,
						filter: null,
						dataCell: OrderLinesHyperlinkCellData,
						onClick: item => this.routes.detail(item.id),
						propertyToCheck: 'product',
						translation: 'ORDERLINEVIEW.UNLINKEDORDERLINE',
					},
					{
						key: 'product.productUpcs.upc',
						title: 'ORDERLINEVIEW.UPC',
						dataCell: MultipleCellData,
						selected: true,
						width: 200,
						filter: null,
						isOrderLineView: true,
					},
					{
						key: 'quantity',
						title: 'ORDERLINEVIEW.QUANTITY',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'unitPrice',
						title: 'ORDERLINEVIEW.UNITPRICE',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'discount',
						title: 'Discount',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'orderLineStatus.name',
						title: 'ORDERLINEVIEW.STATUS',
						selected: true,
						width: 200,
						filter: null,
					},
				],
				sortObject: [],
				actions: {
					onLinkOrderLine: async orderLine =>
						this.openModal({
							data: { refreshPage: this.refreshPage, orderLineId: orderLine.id },
							component: LinkOrderLine,
						}),
					onRefundOrderLine: async orderLine => this.openConfirmationModal(this.getRefundConfirmModalProps(orderLine)),
				},
			},
			permissions: {
				onLinkOrderLine: () => this.authStore.hasPermission('marketplaceOrderSection.full'),
				onRefundOrderLine: () => this.authStore.hasPermission('marketplaceOrderSection.full'),
				update: () => this.authStore.hasPermission('marketplaceOrderSection.update'),
				create: () => this.authStore.hasPermission('marketplaceOrderSection.create'),
				remove: () => this.authStore.hasPermission('marketplaceOrderSection.delete'),
				read: () => this.authStore.hasPermission('marketplaceOrderSection.read'),
				full: () => this.authStore.hasPermission('marketplaceOrderSection.full'),
			},
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
						id,
					}),
			},
		});
		this.refreshPage = componentProps.refreshPage;
		makeObservable(this);
		this.queryUtility.initialize(this.findOrderLines);
		this.orderLineStore = new OrderLineStore(rootStore);
		this.hasPiiAccess = this.rootStore.authStore.hasPiiAccess;
		this.isChannelAmazon =
			componentProps.channel != null ? componentProps.channel.channelType.name == channelType.amazon : null;
		this.hasAllFOsPastExitScan = componentProps.hasAllFOsPastExitScan;
	}

	getRefundConfirmModalProps = item => {
		return {
			onConfirm: async () => await this.refundOrderLine(this.rootStore.viewStore.selectedConfirmModal.data),
			message: ['ORDERVIEW.REFUNDORDERLINECONFIRM'],
			data: item,
		};
	};

	@action.bound
	refundOrderLine = async selectedItem => {
		this.suspend();
		try {
			const {
				data: { total, canceled, refunded, message },
			} = await this.orderLineStore.refundOrderLine(selectedItem.id, sourceOfChange.refundOrderLine);
			if (message) {
				this.rootStore.notificationStore.error(message);
			} else {
				this.rootStore.notificationStore.success([
					'ORDERVIEW.REFUNDORDERLINESSUCCESS',
					{ total, refunded, failed: total - (canceled + refunded) },
				]);
				await this.queryUtility.initialize(false);
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};

	@action.bound setAsChanged() {
		this.change = !this.change;
	}

	@action.bound async findOrderLines() {}

	linkOrderLineModal = new ModalParams();
}

export default OrderLinesListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/OrderLinesListViewStore.js